module.exports = __webpack_public_path__ + "static/media/CourseCertificates.96391bb0.svg";